import { createTheme } from '@mui/material/styles';
import { adaptV4Theme } from '@mui/material';

const tableTheme = createTheme(adaptV4Theme({
  overrides: {
    MuiTableRow: {
      hover: {
        '&:hover': {
          backgroundColor: 'rgba(233, 143, 10, 0.15)!important',
        },
      },
    },
  },
}));

export default tableTheme;
